import React from "react";
import { PoputBox } from "./styles";

function Poput() {
    return(
        <PoputBox />
    )
}

export default Poput;